import {
  QueryClient,
  QueryObserver,
  MutationObserver,
} from "./tanstack.query-core.js";
window.TanstackQuery = { QueryClient, QueryObserver, MutationObserver };
const queryClient = new TanstackQuery.QueryClient();
window.queryClient = queryClient;
window.query = ({ key, fn, subscribeFn }) => {
  const queryObserver = new TanstackQuery.QueryObserver(queryClient, {
    queryKey: [key],
    queryFn: fn,
  });

  queryObserver.subscribe((result) =>
    subscribeFn(result, queryObserver.unsubscribe)
  );
};

window.createMutation = ({ mutationFn, subscribeFn, scope, onSuccess, onError, onSettled }) => {
  const mutationObserver = new TanstackQuery.MutationObserver(queryClient, {
    mutationFn,
    scope,
    onSuccess,
    onError,
    onSettled,
  });
  
  mutationObserver.subscribe(subscribeFn ?? (() => {}));

  return mutationObserver;
};
